"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addGlobalPublishers = addGlobalPublishers;

var _typeGuards = require("@insided/shared/utils/typeGuards");

var _globals = require("@insided/shared/utils/globals");

var isGlobalPublisherListenerAttached = false;

function handleGlobalPublisherClick(event) {
  var target = event.target;
  if (!(target instanceof Element)) return;
  var element = target.closest('[data-trigger]');
  if (!(0, _typeGuards.isHtmlElement)(element)) return;
  event.preventDefault();

  if (element.dataset.trigger === 'quote') {
    var _element$dataset$cont;

    if (!element.dataset.username) return;
    (0, _globals.publish)('quote', {
      username: element.dataset.username,
      content: (_element$dataset$cont = element.dataset.content) !== null && _element$dataset$cont !== void 0 ? _element$dataset$cont : ''
    });
  }
}
/**
 * Wires up `[data-trigger]` click publishers with event delegation so startup
 * avoids scanning the full document and attaching per-element listeners.
 */


function addGlobalPublishers() {
  if (isGlobalPublisherListenerAttached) return;
  document.addEventListener('click', handleGlobalPublisherClick);
  isGlobalPublisherListenerAttached = true;
}